import axios from 'axios'
import { instance } from '../utils/http.js';

const BASE_OPERATE_URL = 'https://js.sitestar.cn/ajax/operate.ashx';


/**
 * 获取极速建站资讯分类列表
 */
export const getNewsCategories = () => {
  return axios.get(BASE_OPERATE_URL, {
    params: {
      module: 'SiteNewsCategories'
    }
  });
};

/**
 * 获取分类下的资讯文章列表
 * @param {number} cid 分类ID
 * @param {number} index 页码（默认 1）
 */
export const getNewsList = (cid, index = 1) => {
  return axios.get(BASE_OPERATE_URL, {
    params: {
      module: 'SiteNewsList',
      cid: cid,
      index: index
    }
  });
};

/**
 * 获取资讯文章详情
 * @param {number} nid 文章ID
 */
export const getNewsDetails = (nid) => {
  return axios.get(BASE_OPERATE_URL, {
    params: {
      module: 'SiteNewsDetails',
      nid: nid
    }
  });
};


/**
 * 获取热门知识列表
 */
export const getHotNewsList = () => {
  return axios.get(BASE_OPERATE_URL, {
    params: {
      module: 'SiteHotNewsLis'
    }
  });
};

/**
 * 获取广告列表
 */
export const getAdList = () => {
  return axios.get(BASE_OPERATE_URL, {
    params: {
      module: 'SiteADList'
    }
  });
};

/**
 * 搜索资讯
 * @param {string} searchkey 搜索关键字
 * @param {number} index 页码（默认1）
 */
export const searchNewsList = (searchkey, index = 1) => {
  return axios.get(BASE_OPERATE_URL, {
    params: {
      module: 'SiteSearchNewsList',
      searchkey,
      index
    }
  });
};



/**
 * 获取标签列表
 */
export const getTagList = () => {
  return axios.get(BASE_OPERATE_URL, {
    params: {
      module: 'SiteTagList'
    }
  });
};

/**
 * 获取指定标签的文章列表
 * @param {string} tid 标签别名
 * @param {number} index 页码（默认第1页）
 */
export const getTagNewsList = (tid, index = 1) => {
  return axios.get(BASE_OPERATE_URL, {
    params: {
      module: 'SiteTagNewsList',
      tid,
      index
    }
  });
};


// WEBPACK FOOTER //
// ./src/api/new.js